<template>
    <div>
        <a-upload list-type="picture-card" accept="image/jpeg,image/png" :file-list="files" action="action" :before-upload="beforeUpload" :customRequest="doUpload" @preview="onPreview" @change="onChange">
            <div v-if="canUpload">
                <a-icon type="plus" :style="{ fontSize: '32px', color: '#999' }" />
                <div :style="{ marginTop: '8px', color: '#666' }">
                    上传图片
                </div>
            </div>
        </a-upload>
        <a-modal :visible="preview" :footer="null" @cancel="() => (preview = false)">
            <img style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            required: true
        },
        max: {
            type: Number,
            required: false,
            default: 5
        },
        imgs: {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            preview: false,
            previewImage: '',
            files: []
        }
    },

    computed: {
        canUpload() {
            return this.files.length < this.max
        }
    },
    mounted() {
        this.initImages(this.imgs)
    },
    methods: {
        initImages(fs) {
            this.files = []
            if (!fs) {
                return
            }
            let i = 0
            fs.split(',').forEach(v => {
                this.files.push({
                    uid: i--,
                    name: v.split('?')[0].split('/')[v.split('?')[0].split('/').length - 1],
                    status: 'done',
                    url: v
                })
            })
        },
        fileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },
        onChange({ fileList }) {
            this.files = fileList
            this.$emit('update:imgs', this.files.map(file => (file ? file.url || (file.response ? file.response.url : '') : '')).join())
        },
        async onPreview(file) {
            if (!file.url && !file.preview) {
                file.preview = await this.fileToBase64(file.originFileObj)
            }
            this.previewImage = file.url || file.preview
            this.preview = true
        },
        doUpload(upload) {
            this.loading = true
            this.$http
                .post(
                    '/sys/base/upload/image',
                    {
                        file: upload.file,
                        type: this.type
                    },
                    {
                        onUploadProgress: progressEvent => {
                            const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0
                            upload.onProgress({
                                percent: complete
                            })
                        }
                    }
                )
                .then(result => {
                    this.loading = false
                    if (result.code === 0) {
                        let obj = {
                            name: upload.file.name,
                            url: result.data.url
                        }
                        upload.onSuccess(obj)
                    }
                })
                .catch(err => {
                    this.loading = false
                    upload.onError(err)
                })
        },
        beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
            if (!isJpgOrPng) {
                this.$message.error('请上传[JPEG/PNG]格式图片')
            }
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) {
                this.$message.error('请上传小于2MB的图片文件')
            }
            return isJpgOrPng && isLt2M
        }
    }
}
</script>
